import { createTheme } from "@mui/material";

export default createTheme({
	palette: {
		// mode: "dark"
		primary: {
			main: "#CC0100"
		},
		info: {
			main: "#BD782C"
		},
		secondary: {
			main: "#041C78"
		},
		grey: {
			"500": "#3D3C36"
		}
	}
})
